// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f5qe6k1 {
  width: 100%;
}
.f5qe6k2 {
  gap: 20px 40px;
}
.f5qe6k3 {
  font-size: 15px;
  color: #9b9b9b;
}
.f5qe6k4:hover {
  text-decoration: underline;
}
.f5qe6k5 {
  width: 82.5%;
}
.f5qe6k6:hover {
  text-decoration: underline;
}
.f5qe6k7 {
  max-width: 17.5%;
}
@media screen and (min-width: 768px) {
  .f5qe6k0 {
    position: relative;
    left: calc(50% + 10px);
  }
  .f5qe6k1 {
    width: calc(50% - 10px);
  }
  .f5qe6k3 {
    font-size: 17px;
    font-weight: 500;
  }
}
@media (min-width: 768px) {
  .f5qe6k5 {
    width: calc(42.5% - 100px);
    flex-grow: 1;
    padding-left: var(--_18w76bwm);
  }
  .f5qe6k7 {
    max-width: var(--_18w76bw13);
    min-height: var(--_18w76bw13);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,YAAY;IACZ,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;AACF","sourcesContent":[".f5qe6k1 {\n  width: 100%;\n}\n.f5qe6k2 {\n  gap: 20px 40px;\n}\n.f5qe6k3 {\n  font-size: 15px;\n  color: #9b9b9b;\n}\n.f5qe6k4:hover {\n  text-decoration: underline;\n}\n.f5qe6k5 {\n  width: 82.5%;\n}\n.f5qe6k6:hover {\n  text-decoration: underline;\n}\n.f5qe6k7 {\n  max-width: 17.5%;\n}\n@media screen and (min-width: 768px) {\n  .f5qe6k0 {\n    position: relative;\n    left: calc(50% + 10px);\n  }\n  .f5qe6k1 {\n    width: calc(50% - 10px);\n  }\n  .f5qe6k3 {\n    font-size: 17px;\n    font-weight: 500;\n  }\n}\n@media (min-width: 768px) {\n  .f5qe6k5 {\n    width: calc(42.5% - 100px);\n    flex-grow: 1;\n    padding-left: var(--_18w76bwm);\n  }\n  .f5qe6k7 {\n    max-width: var(--_18w76bw13);\n    min-height: var(--_18w76bw13);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
